import { useEffect, useState } from "react";

// Falling gold coins celebration for wins.
export default function CoinRain({ fire }) {
  const [coins, setCoins] = useState([]);

  useEffect(() => {
    if (!fire) return;
    const arr = Array.from({ length: 28 }).map((_, i) => ({
      id: `${fire}-${i}`,
      left: Math.random() * 100,
      delay: Math.random() * 0.5,
      dur: 1.3 + Math.random() * 1.2,
      size: 20 + Math.random() * 20,
      spin: Math.random() > 0.5,
    }));
    setCoins(arr);
    const timer = setTimeout(() => setCoins([]), 3000);
    return () => clearTimeout(timer);
  }, [fire]);

  if (!coins.length) return null;
  return (
    <div className="fixed inset-0 pointer-events-none z-[95] overflow-hidden" data-testid="coin-rain">
      {coins.map((c) => (
        <div
          key={c.id}
          style={{
            position: "absolute",
            top: "-8vh",
            left: `${c.left}%`,
            width: c.size,
            height: c.size,
            animation: `confetti-fall ${c.dur}s cubic-bezier(0.3,0.1,0.5,1) ${c.delay}s forwards`,
          }}
        >
          <div
            className="grid place-items-center rounded-full font-bold text-[#7a5c00]"
            style={{
              width: "100%",
              height: "100%",
              background: "radial-gradient(circle at 35% 30%, #FFF3b0, #FFD700 55%, #C9A227)",
              boxShadow: "0 0 10px rgba(255,215,0,0.7), inset 0 0 4px rgba(0,0,0,0.25)",
              fontSize: c.size * 0.55,
            }}
          >
            ₹
          </div>
        </div>
      ))}
    </div>
  );
}
